import React, { useState } from 'react';
import { RegularButton } from 'fronton-react';
import { IdentificationBadgeIcon } from '@fronton/icons-react';
import { useStoreon } from 'storeon/react';
import { B2BOrganizationsStore } from 'reducers/b2b-organization';
import { UserMenuTooltip } from './user-menu-tooltip';
import { ChangeOrganizationPopup } from './change-organization-popup';
import { B2B_ORGANIZATION_ACTIONS } from 'actions/b2b-organization';
import { useTranslation } from 'react-i18next';

type B2BUserMenuProps = {
  onLogout: () => void;
};

export const B2BUserMenu = (props: B2BUserMenuProps) => {
  const { B2BOrganizations, dispatch } = useStoreon<B2BOrganizationsStore>('B2BOrganizations');
  const { currentOrganizationName, currentOrganizationNumber, list } = B2BOrganizations;

  const [isVisibleTooltip, setVisibleTooltip] = useState(false);
  const [isVisiblePopup, setVisiblePopup] = useState(false);
  const { t } = useTranslation();

  const showChangeOrganizationPopup = () => {
    setVisibleTooltip(false);
    setVisiblePopup(true);
  };

  const onApplyButtonClick = (organizationNumber: string) => {
    dispatch(B2B_ORGANIZATION_ACTIONS.setCurrentOrganizationNumber, organizationNumber);

    setVisibleTooltip(false);
    setVisiblePopup(false);
  };

  const onPopupClose = () => {
    setVisiblePopup(false);
  };

  return (
    <>
      <UserMenuTooltip
        onLogout={props.onLogout}
        isVisibleTooltip={isVisibleTooltip}
        organizationName={currentOrganizationName}
        organizationCount={B2BOrganizations.list.length}
        setVisibleTooltip={setVisibleTooltip}
        showChangeOrganizationPopup={showChangeOrganizationPopup}
      >
        <RegularButton
          size="l"
          iconOnly
          label={t('header.main.profile-low')}
          rounded
          disabled={isVisibleTooltip}
          onClick={() => setVisibleTooltip(true)}
          variant="secondary"
        >
          <IdentificationBadgeIcon type="outline" />
        </RegularButton>
      </UserMenuTooltip>
      <ChangeOrganizationPopup
        visible={isVisiblePopup}
        list={list}
        currentOrganizationNumber={currentOrganizationNumber || ''}
        onApplyClick={onApplyButtonClick}
        onClose={onPopupClose}
      />
    </>
  );
};
